
import React, { useState } from "react";
import { toast } from "react-toastify";
import NewFileUpload from "./NewFileUpload";

import type { ExistingFile } from "./NewFileUpload";
import type { ManagerScheduledOrder, } from "../interface/ScheduledOrder ";

import {
  formatScheduleDate,
  formatScheduleTime,
} from "../utils/scheduledOrders";

interface ScheduledScanUploadModalProps {
  order: ManagerScheduledOrder;
  onClose: () => void;
  onUpload: (caseID: number, files: File[]) => Promise<boolean>;
}

const ScheduledScanUploadModal: React.FC<
  ScheduledScanUploadModalProps
> = ({ order, onClose, onUpload }) => {
  const [scans, setScans] = useState<(File | ExistingFile)[]>([]);
  const [uploading, setUploading] = useState(false);

  const handleUpload = async () => {
    const newFiles = scans.filter(
      (file): file is File => file instanceof File
    );

    if (!newFiles.length) {
      toast.error("Please select scan files first.");
      return;
    }

    setUploading(true);

    try {
      const success = await onUpload(order.caseID, newFiles);

      if (success) {
        onClose();
      }
    } finally {
      setUploading(false);
    }
  };

  return (
    <div
      className="modal fade show d-block"
      style={{
        backgroundColor: "rgba(15, 23, 42, 0.55)",
        zIndex: 1055,
      }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <div>
              <h5 className="modal-title">Upload Scheduled Scan</h5>
              <small className="text-muted">
                Order: {order.orderId} | {order.clinic}
              </small>
              <div className="small text-muted">
                {formatScheduleDate(order.scheduleDate)} —{" "}
                {formatScheduleTime(order.scheduleTime)}
              </div>
            </div>

            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
              disabled={uploading}
            />
          </div>

          <div className="modal-body">
            <NewFileUpload
              scans={scans}
              setScans={setScans}
              setActiveStep={() => {}}
            />
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
              disabled={uploading}
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={handleUpload}
              disabled={uploading || scans.length === 0}
            >
              {uploading ? "Uploading..." : "Upload Scans"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduledScanUploadModal;
